import { render, staticRenderFns } from "./BetaAccess.vue?vue&type=template&id=2f297668&scoped=true&"
import script from "./BetaAccess.vue?vue&type=script&lang=ts&"
export * from "./BetaAccess.vue?vue&type=script&lang=ts&"
import style0 from "./BetaAccess.vue?vue&type=style&index=0&id=2f297668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f297668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VContainer,VDataTable,VFlex,VLayout,VSwitch})
